<template>
  <div
    class="bg-gradient-to-r from-[#0d4169] to-[#0d4169] min-h-screen w-full bg-cover bg-center flex flex-col md:flex-row overflow-y-auto md:overflow-hidden">
    <!-- left welcome panel -->
    <div class="w-full md:w-1/2 flex items-center justify-center p-6 md:p-4">
  <div class="text-white max-w-lg text-center">

    <!-- Logo -->
    <img
      width="300"
      height="150"
      src="../assets/logo1.png"
      alt="Mina Software"
      class="mx-auto lg:mx-0"
    />

    <!-- Phone -->
    <a
      href="tel:0930481818"
      class="flex items-center justify-center  gap-2 text-sm font-bold text-white hover:text-white/90 transition-colors whitespace-nowrap mt-4"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-white shrink-0"
        aria-hidden="true"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>

      <span class="text-2xl md:text-xl font-extrabold">
        0930481818
      </span>
    </a>

    <!-- Title -->
    <!-- <h1 class="text-2xl md:text-3xl font-extrabold mt-6 text-center">
      Mina Software
    </h1> -->

  </div>
</div>

    <!-- right login card -->
    <div class="w-full md:w-1/2 flex items-center justify-center p-6 md:p-10">
      <div class="w-full max-w-xs bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl p-8 flex flex-col justify-center border border-white/20">
        <h2 class="text-xl font-extrabold text-gray-800 mb-6 text-center">Login In</h2>
        <!-- <h2 class="text-xl font-extrabold text-gray-800 mb-6 text-center">Happy Hour?</h2> -->

        <div v-if="state.showActivationForm" class="space-y-4">
          <p
            v-if="state.activationMessage"
            :class="state.activationMessageType === 'success'
              ? 'text-emerald-600'
              : 'text-red-500'"
            class="text-xs text-center font-medium leading-snug"
          >
            {{ state.activationMessage }}
          </p>

          <template v-if="state.activationMessageType !== 'success' && !isSubscriptionMisuseMessage(state.activationMessage)">
            <div class="flex flex-col gap-1">
              <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Username</label>
              <input
                v-model.trim="form.username"
                type="text"
                autocomplete="username"
                class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                placeholder="Username"
                required
              />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Password</label>
              <input
                v-model.trim="form.password"
                type="password"
                autocomplete="current-password"
                class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                placeholder="Password"
                required
              />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Activation Key</label>
              <input
                v-model.trim="state.activationKey"
                type="text"
                maxlength="9"
                class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm font-mono"
                placeholder="Enter Activation Key"
                required
              />
            </div>
            <button
              type="button"
              :disabled="state.activationLoading"
              class="w-full py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white font-bold rounded-lg shadow-md transition text-sm"
              @click="handleActivate"
            >
              <span v-if="state.activationLoading">Activating...</span>
              <span v-else>Activate</span>
            </button>
          </template>

          <button
            v-else-if="state.activationMessageType === 'success'"
            type="button"
            class="w-full py-2 bg-[#0d4169] hover:bg-[#0a3354] text-white font-bold rounded-lg shadow-md transition text-sm"
            @click="returnToLoginForm"
          >
            Continue to Login
          </button>

          <button
            v-else-if="isSubscriptionMisuseMessage(state.activationMessage)"
            type="button"
            class="w-full py-2 bg-[#0d4169] hover:bg-[#0a3354] text-white font-bold rounded-lg shadow-md transition text-sm"
            @click="returnToLoginForm"
          >
            Back to Login
          </button>
        </div>

        <div v-else-if="state.showBranchSelector" class="space-y-4">
          <!-- <p class="text-[0.82rem] text-slate-600 text-center">
            Please select one to continue.
          </p> -->
          <div class="flex flex-col gap-1">
            <!-- <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Select Organization Unit</label> -->
            <select
              v-model="state.selectedOrgUnit"
              class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
            >
              <option disabled value="">Select Branch</option>
              <option
                v-if="state.companyOption"
                :value="`company:${state.companyOption.id}`"
              >
                {{ state.companyOption.name }} (Head Office)
              </option>
              <option v-for="branch in state.assignedBranches" :key="branch.id" :value="`branch:${branch.id}`">
                {{ state.companyOption?.name ? `${state.companyOption.name} - ` : '' }}{{ branch.name }}
              </option>
            </select>
          </div>
          <p v-if="state.error" class="text-red-500 text-xs text-center">{{ state.error }}</p>
          <button
            type="button"
            :disabled="!state.selectedOrgUnit || state.orgUnitLoading"
            class="w-full py-2 bg-[#0d4169] hover:bg-[#0a3354] disabled:opacity-50 text-white font-bold rounded-lg shadow-md transition text-sm flex items-center justify-center min-h-[40px]"
            @click="handleOrganizationUnitSelected"
          >
            <span v-if="!state.orgUnitLoading">Next</span>
            <div v-else class="flex items-center space-x-1.5">
              <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade"></div>
              <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade [animation-delay:0.2s]"></div>
              <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade [animation-delay:0.4s]"></div>
            </div>
          </button>
        </div>

        <form autocomplete="on" v-else @submit.prevent="handleSubmit" class="space-y-4">
          <div class="flex flex-col gap-1">
            <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Username</label>
           <input
  v-model.trim="form.username"
  type="text"
  name="username"
  list="username-list"
  autocomplete="username"
  class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
  placeholder="Enter your Username"
  required
/>

<datalist id="username-list">
  <!-- <option value="john_doe"></option>
  <option value="jane_smith"></option>
  <option value="alex123"></option> -->
</datalist>
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Password</label>
            <input
              v-model.trim="form.password"
              type="password"
              class="px-2 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
              placeholder="Enter your password"
              required
            />
          </div>

        <p v-if="state.error" class="text-red-500 text-xs text-center">{{ state.error }}</p>

     <button
  type="submit"
  :disabled="state.loading"
  class="w-full py-2 bg-[#0d4169] hover:bg-[#0a3354] disabled:opacity-50 text-white font-bold rounded-lg shadow-md transition text-sm flex items-center justify-center min-h-[40px]"
>
  <span v-if="!state.loading">Log In</span>
  
  <!-- Standard ERP Sequential Fade -->
  <div v-else class="flex items-center space-x-1.5">
    <!-- Dot 1 lights up first -->
    <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade"></div>
    <!-- Dot 2 waits 0.2s -->
    <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade [animation-delay:0.2s]"></div>
    <!-- Dot 3 waits 0.4s -->
    <div class="h-1.5 w-1.5 bg-white rounded-full animate-dot-fade [animation-delay:0.4s]"></div>
  </div>
</button>

        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import store from '../store'
import { nextTick } from 'vue'
import { apiFetch, activateSubscription } from '../utils/api'
import { parseOrgUnitSelection, switchOrgUnit, withResolvedCompanyLogo } from '../utils/authOrgUnit'

const subscriptionExpiredMessage =
  'Your subscription period has ended. Please contact your administrator to renew.'

const subscriptionMisuseMessage =
  'System misuse has been detected. Please contact the administrator.'

function isSubscriptionMisuseMessage(message) {
  return String(message || '').trim() === subscriptionMisuseMessage
}

const router = useRouter()

const form = reactive({
  username: '',
  password: '',
})

const state = reactive({
  error: '',
  loading: false,
  showBranchSelector: false,
  showActivationForm: false,
  activationKey: '',
  activationLoading: false,
  activationMessage: '',
  activationMessageType: '',
  assignedBranches: [],
  selectedOrgUnit: '',
  companyOption: null,
  orgUnitLoading: false,
})

// remove auto redirect on mount

function getAssignedBranchIds(user) {
  const raw = user?.branch_ids || user?.branchIds || ''
  if (!raw) return []
  return String(raw)
    .split(',')
    .map(v => Number(v.trim()))
    .filter(v => Number.isInteger(v) && v > 0)
}

function getAssignedCompanyIds(user) {
  const raw = user?.company_assigned_ids || user?.companyAssignedIds || ''
  if (!raw) return []
  return String(raw)
    .split(',')
    .map(v => Number(v.trim()))
    .filter(v => Number.isInteger(v) && v > 0)
}

function filterActiveAssignedBranches(branches) {
  return (Array.isArray(branches) ? branches : []).filter((data) => {
    if (!data?.id) return false
    // Only offer active branches for organization selection
    if (data.is_active !== undefined && Number(data.is_active) !== 1) return false
    return true
  })
}

async function maybeShowBranchSelector(prefetchedBranches = null) {
  const user = store.getters.currentUser
  const branchId = user?.branchId || user?.branch_id || user?.branch?.id || null
  const assignedIds = getAssignedBranchIds(user)

  const assignedCompanyIds = getAssignedCompanyIds(user)

  const companyId = user?.companyId || user?.company_id || user?.company?.id || null
  const companyName = user?.company?.name || user?.companyName || user?.company_name || 'Company'
  const companyModules = user?.company?.modules ?? null
  const companyLogoUrl = user?.company?.logo_url || user?.companyLogo || user?.company_logo || null

  const canSelectCompany = !!(companyId && assignedCompanyIds.includes(Number(companyId)))
  state.companyOption = canSelectCompany
    ? { id: companyId, name: companyName, modules: companyModules, logo_url: companyLogoUrl }
    : null

  if (!branchId && assignedIds.length > 0) {
    // Prefer branches returned by login (one DB query). Fallback only if older API.
    let results = Array.isArray(prefetchedBranches)
      ? filterActiveAssignedBranches(prefetchedBranches)
      : null

    if (!results) {
      const fetched = await Promise.all(
        assignedIds.map(async (id) => {
          try {
            const res = await apiFetch(`/branches/${id}`)
            if (!res.ok) return null
            return await res.json()
          } catch {
            return null
          }
        })
      )
      results = filterActiveAssignedBranches(fetched)
    }

    state.assignedBranches = results
    state.selectedOrgUnit = ''
    state.showBranchSelector = state.assignedBranches.length > 0 || !!state.companyOption
    return state.showBranchSelector
  }

  state.showBranchSelector = false
  state.assignedBranches = []
  state.selectedOrgUnit = ''
  state.companyOption = null
  return false
}

async function handleOrganizationUnitSelected() {
  const parsed = parseOrgUnitSelection(state.selectedOrgUnit)
  if (!parsed) return

  state.orgUnitLoading = true
  state.error = ''
  try {
    const data = await switchOrgUnit({
      orgType: parsed.type,
      orgId: parsed.selectedId,
    })

    store.commit('setAuth', {
      token: data.token,
      user: data.user,
      source: store.state.loginSource
    })

    router.push({ name: 'dashboard' })
    await nextTick()
    window.scrollTo(0, 0)
  } catch (err) {
    state.error = err.message || 'Failed to select organization unit'
  } finally {
    state.orgUnitLoading = false
  }
}

async function handleSubmit() {
  state.error = '';
  state.loading = true;
  try {
    const loginResult = await store.dispatch('login', {
      username: form.username,
      password: form.password,
      source: 'standard'
    });

    store.commit('setAuth', {
      token: loginResult.token,
      user: withResolvedCompanyLogo(loginResult.user),
      source: 'standard'
    })

    // successful login: if account has assigned branch_ids but no branch_id, stay here and show branch selector
    const requiresBranchSelection = await maybeShowBranchSelector(loginResult.assignedBranches)
    if (!requiresBranchSelection) {
      router.push({ name: 'dashboard' });
      await nextTick()
      window.scrollTo(0, 0)
    }
  } catch (err) {
    if (err.code === 'SUBSCRIPTION_MISUSE' || isSubscriptionMisuseMessage(err.message)) {
      store.dispatch('logout')
      state.showActivationForm = false
      state.activationMessage = ''
      state.activationMessageType = ''
      state.activationKey = ''
      state.error = err.message || subscriptionMisuseMessage
    } else if (err.code === 'SUBSCRIPTION_EXPIRED') {
      store.dispatch('logout')
      state.showActivationForm = true
      state.activationMessage = err.message || subscriptionExpiredMessage
      state.activationMessageType = 'error'
      state.error = ''
    } else {
      state.error = err.message || 'Login failed'
    }
  } finally {
    state.loading = false;
  }
}

async function handleActivate() {
  state.activationLoading = true
  try {
    if (!form.username?.trim() || !form.password?.trim()) {
      throw new Error('Username and password are required.')
    }
    if (!state.activationKey?.trim()) {
      throw new Error('Activation key is required.')
    }

    const data = await activateSubscription({
      username: form.username,
      password: form.password,
      activationKey: state.activationKey
    })

    state.activationMessage = data.message || 'Activation successful. You can now sign in.'
    state.activationMessageType = 'success'
    state.activationKey = ''
    router.replace({ name: 'login', query: {} })
  } catch (err) {
    state.activationMessage = err.message || 'Activation failed'
    state.activationMessageType = 'error'
  } finally {
    state.activationLoading = false
  }
}

function returnToLoginForm() {
  state.showActivationForm = false
  state.activationMessage = ''
  state.activationMessageType = ''
  state.activationKey = ''
  state.error = ''
  form.password = ''
}

onMounted(async () => {
  state.showBranchSelector = false
  state.assignedBranches = []
  state.selectedOrgUnit = ''
  state.companyOption = null

  // Check for session expiry query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const isExpired = urlParams.get('session') === 'expired'
  const reason = urlParams.get('reason')
  const explicitMessage = urlParams.get('message')
  if (isExpired && reason === 'subscription') {
    store.dispatch('logout')
    const redirectMessage = explicitMessage || subscriptionExpiredMessage
    if (isSubscriptionMisuseMessage(redirectMessage)) {
      state.showActivationForm = false
      state.activationMessage = ''
      state.activationMessageType = ''
      state.activationKey = ''
      state.error = redirectMessage
    } else {
      state.showActivationForm = true
      state.activationMessage = redirectMessage
      state.activationMessageType = 'error'
      state.error = ''
    }
    router.replace({ name: 'login', query: {} })
  } else if (isExpired && reason === 'clock') {
    state.error = explicitMessage || 'Date and time issue, please check your server date and time.'
  } else if (isExpired) {
    state.error = 'Your session has expired due to inactivity. Please log in again.';
  }
});
</script>

<style scoped>
</style>

<!-- npx prisma db push -->

<!-- nice now in dailyInventorypage.vue by default the Department Inventory table is empty then when department selected list all items/product which are in the recipe_ingridents and in this specific department. if the ingrident was product type U.O.M st empty, 	Qty Pack	and Qty Single are fields by default 0, U.Price Pack(if it is item can be feched from sivitems latest unit_price_details.split(",")[length-1] or Non-stockable lates unit_price_details.split(",")[length-1] sivitemes latest compared with non-stockable latest then choose the latest unit price based on thier created date, but if it is product the U.Price Pack is the same as Unit Cost as in productPage calculated), U.Price Single(if it is item check the U.O.M st	and U.O.M pro(f.b) if both are the same example KG  KG or Liter  Liter etc  U.Price Single is the same as U.Price Pack, if both(U.O.M st and U.O.M pro(f.b)) are in the same measurement but not the same example KG  g or liter  ML etc U.Price Single = U.Price Pack divide by 1000, if it is product U.Price Single is the same as U.Price Pack  ), T.Price sum of both Qty Pack*U.Price Pack + Qty Single*U.Price Single,  Remark is field finally when save button clicked save it in daily Inventory if not exist auto create, including fields like company id and branch id(nullable based on the creater or user token ids), created by, created at, calander, department id, item and product id type(item or product) etc. in the Department Inventory page when Ingredient Names listed must unique names no dublication and highlight for products by light green like in the productpage ingrident you did, please implement carefully in both frontend and backend  -->



